@if (optionsMetaproducts.options) {
  <div class="options-metaproduct">
    @if (!showDropdown) {
      <div class="options-title">
        <p i18n="@@optionsMetaproducts.options">Options:</p>
      </div>
      <ul class="options-selector">
        @for (product of optionsMetaproducts.options; track product) {
          <li [ngClass]="{ selected: product.id === selectedOption }">
            <a
              class="options-link"
              tabindex="0"
              data-gtmaction="event_buy_now_choose_product"
              data-gtmcategory="event_bin_action"
              [attr.data-gtmlabel]="product.label + '_' + product.title"
              (click)="redirectToOptionSelected(product.id); gtmEvent($event)"
              (keypress)="redirectToOptionSelected(product.id)"
            >
              <span class="options-name">{{ product.label }}</span>
              @if (showOptionPrice) {
                <span class="options-price">
                  <span class="options-price__total">
                    {{ product.price | currency: currency : 'symbol' : '1.2-2' }}
                  </span>
                  <app-meta-option-crossed-price
                    [productPriceInfo]="getOptionPriceInfo(product)"
                    [feedId]="feedId"
                    [bundleRecommendedPricesProducts]="product"
                  />
                </span>
              }
            </a>
          </li>
        }
      </ul>
    } @else {
      <div class="dropup options__dropdown" [ngClass]="{ show: dropdownOpen() }">
        <button class="dropdown-toggle button" type="button" id="colorDropdown" (click)="toggleDropdown()">
          <span class="dropdown-toggle__text">
            <span class="dropdown-label" i18n="@@optionsMetaproducts.options">Options:</span>
            @for (product of optionsMetaproducts.options; track product) {
              @if (product.id === optionsMetaproducts.parentProduct?.id) {
                <span class="dropdown-selected">
                  {{ product.label }}
                </span>
              }
            }
          </span>
          <i class="fas fa-chevron-up"></i>
        </button>
        <ul class="dropdown-menu" aria-labelledby="colorDropdown" [ngClass]="{ show: dropdownOpen() }">
          @for (product of optionsMetaproducts.options; track product) {
            <li class="dropdown-item" [ngClass]="{ selected: product.id === selectedOption }">
              <a
                (click)="redirectToOptionSelected(product.id); gtmEvent($event)"
                (keypress)="redirectToOptionSelected(product.id)"
              >
                {{ product.label }}
              </a>
            </li>
          }
        </ul>
      </div>
    }
  </div>
}
